import React from "react";
import { SectionHeader } from "../../components/section-header.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { MapProxy } from "../../components/map/map-proxy.tsx";
import type { MapMarker } from "../../components/map/map-marker.ts";
export interface BranchMapProps {
  branches: Branch[];
}
export interface Branch {
  location: Location;
  name: string;
  displayAddress: string;
  phoneNumber?: string | null;
  faxNumber?: string | null;
}
interface Location {
  lat: number;
  lon: number;
}

export const BranchMap: React.FC<BranchMapProps> = ({ branches }) => {
  if (branches.length === 0) return null;

  return (
    <div className={"flex flex-col gap-4.5"}>
      <SectionHeader text={"Our locations"} as="h2" className={`leading-none md:leading-none ${FontStyles.h5}`} />
      <MapProxy markers={branchesToMarkers(branches)} containerClass={"h-[300px] md:h-[440px] shadow-espc"} />
    </div>
  );
};

function branchesToMarkers(branches: BranchMapProps["branches"]): MapMarker[] {
  return branches.map((branch) => ({
    location: branch.location,
    markerType: "branch" as const,
    popup: {
      title: branch.name,
      infoItems: [
        { icon: "fa-sharp fa-solid fa-building", text: branch.displayAddress },
        ...(branch.phoneNumber ? [{ icon: "fa-sharp fa-solid fa-phone", text: branch.phoneNumber }] : []),
      ],
    },
  }));
}
